import { TypeActionContractInfo } from "../actionContractInfo";
import { epicContractInfoFactory } from "./epicContractInfoFactory";
export var epicContractInfoRequest = epicContractInfoFactory(TypeActionContractInfo.Request);



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicContractInfoRequest.ts
// module id = 1995
// module chunks = 3